<template>
  <header class="layout-head">
    <!-- <head-banner /> -->
    <head-nav v-if="$route.name != 'Index'" />
  </header>
</template>

<script>
import HeadBanner from '@/layout/components/LayoutHead/HeadBanner.vue'
import HeadNav from '@/layout/components/LayoutHead/HeadNav2/index.vue'
export default {
  name: 'LayoutHead',
  components: { HeadBanner, HeadNav },
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>
